import { IComplementaryReport } from '@modeso/types__aumico-lib-annualreport-be';
import { ITranslatorVisitor } from '../ITranslatorVisitor.interface';

export class ComplementaryReports {
    constructor(public complementaryReports: IComplementaryReport[]) {}

    public accept(visitor: ITranslatorVisitor) {
        visitor.visit(this);
    }
}
